import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const SubmitButton = ({
  submitting,
  disabled,
  keyword
}) => {
  if (submitting) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: "56px"
    });
  }
  const message = keyword === 'next' ? 'login.form.next' : 'login.form.button';
  return /*#__PURE__*/_jsx(Button, {
    block: true,
    "data-test-id": "password-login-button",
    id: "loginBtn",
    type: "submit",
    use: "primary",
    disabled: disabled,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    })
  });
};
SubmitButton.propTypes = {
  submitting: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  keyword: PropTypes.string
};
export default SubmitButton;